import { create } from "zustand";

export const usePreferences = create((set, get) => ({
  nickname: "",
  setNickname(nickname) {
    set({nickname})
  }
}))